import 'css-chunksrc/client/scenes/fillAccount/error/styles.scss';export default {
  "error": "_error_1o2ik_1",
  "text": "_text_1o2ik_5"
};